import { render, staticRenderFns } from "./SteelspaceLogo.svg.vue?vue&type=template&id=13635f7f&scoped=true"
import script from "./SteelspaceLogo.svg.vue?vue&type=script&lang=ts"
export * from "./SteelspaceLogo.svg.vue?vue&type=script&lang=ts"
import style0 from "./SteelspaceLogo.svg.vue?vue&type=style&index=0&id=13635f7f&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13635f7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13635f7f')) {
      api.createRecord('13635f7f', component.options)
    } else {
      api.reload('13635f7f', component.options)
    }
    module.hot.accept("./SteelspaceLogo.svg.vue?vue&type=template&id=13635f7f&scoped=true", function () {
      api.rerender('13635f7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/SteelspaceLogo.svg.vue"
export default component.exports